
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenUserFeedback {

    description: string;
    type: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genUserFeedback: GenUserFeedback);

    constructor( input?: GenUserFeedback ) {
        if ( input && typeof input !== 'number' ) {
            this.description = input.description; // string [string]
            this.type = input.type; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenUserFeedback[] {
        if (arr && arr.map) {
          return arr.map(a => new GenUserFeedback(a));
        } else {
          return [];
        }
    }
}

